function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6703 0.288185C19.3013 3.49178 26.5153 17.2019 28.4212 24.1055C30.5906 31.963 5.67093 29.2578 0.919137 24.1055C-3.68471 19.1133 10.2794 -2.74927 14.6703 0.288185Z",
  fill: "#F26724"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7961 19.1974C15.5289 19.1974 16.1547 18.9578 16.6477 18.4782C17.1406 17.9855 17.3938 17.3859 17.3938 16.6667C17.3938 15.9605 17.1406 15.3745 16.6477 14.9085C16.1547 14.4288 15.5289 14.189 14.7961 14.189H13.03V19.1974H14.7961ZM14.7961 12.1643C16.2215 12.1643 17.3938 12.5905 18.3126 13.4296C19.2318 14.269 19.6848 15.348 19.6848 16.6667C19.6848 18.0121 19.2318 19.1043 18.3126 19.9567C17.3938 20.7958 16.2215 21.2223 14.7961 21.2223H10.7788V12.1643H14.7961Z",
  fill: "#302166"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.5797 16.1371H30.6679C30.1712 16.1371 29.7687 16.5396 29.7687 17.0363C29.7687 17.533 30.1712 17.9355 30.6679 17.9355H32.3285C31.8491 18.8544 31.0765 19.3207 30.0241 19.3207C29.2382 19.3207 28.612 19.0676 28.1191 18.5746C27.6397 18.082 27.3999 17.4691 27.3999 16.7366C27.3999 15.9371 27.6397 15.2847 28.1191 14.7917C28.5987 14.2988 29.2249 14.0456 30.0108 14.0456C31.0898 14.0456 31.7824 14.4987 32.1155 15.391H34.4864C34.3 14.3389 33.7805 13.4995 32.9414 12.9002C32.102 12.2874 31.1031 11.9811 29.9574 11.9811C28.5721 11.9811 27.4132 12.4339 26.494 13.3397C25.5749 14.2323 25.1221 15.391 25.1221 16.7898C25.1221 18.1086 25.5749 19.2008 26.4807 20.0934C27.3663 20.953 28.4947 21.3911 29.8519 21.4101L29.851 21.4113C29.862 21.4113 29.8727 21.4107 29.8837 21.4107C29.9039 21.411 29.9239 21.4119 29.9444 21.4119C30.0573 21.4119 30.1677 21.4069 30.2767 21.3994C35.3394 21.1348 34.5797 16.1371 34.5797 16.1371Z",
  fill: "#302166"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.2646 13.1674C21.2646 12.5595 21.7573 12.0665 22.3653 12.0665C22.9732 12.0665 23.4662 12.5595 23.4662 13.1674V20.2147C23.4662 20.8226 22.9732 21.3153 22.3653 21.3153C21.7573 21.3153 21.2646 20.8226 21.2646 20.2147V13.1674Z",
  fill: "#302166"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.438 13.1674C36.438 12.5595 36.9306 12.0665 37.5386 12.0665C38.1466 12.0665 38.6395 12.5595 38.6395 13.1674V20.2147C38.6395 20.8226 38.1466 21.3153 37.5386 21.3153C36.9306 21.3153 36.438 20.8226 36.438 20.2147V13.1674Z",
  fill: "#302166"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.845 16.6781L49.6079 13.9395C50.0379 13.5098 50.0379 12.8126 49.6079 12.3829C49.1779 11.9529 48.481 11.9529 48.051 12.3829L45.2881 15.1216L46.845 16.6781Z",
  fill: "#F26724"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.5994 19.4414L42.541 12.3829C42.111 11.9529 41.414 11.9529 40.9841 12.3829C40.5541 12.8126 40.5541 13.5098 40.9841 13.9395L43.7352 16.6906L40.9841 19.4414C40.5541 19.8713 40.5541 20.5683 40.9841 20.9982C41.414 21.4279 42.111 21.4279 42.541 20.9982L45.2918 18.2471L48.0426 20.9982C48.4725 21.4279 49.1695 21.4279 49.5994 20.9982C50.0294 20.5683 50.0294 19.8713 49.5994 19.4414Z",
  fill: "#302166"
});

var SvgLogoDigix = function SvgLogoDigix(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoDigix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-digix.3a78e4b8.svg";
export { ForwardRef as ReactComponent };